import API_ENDPOINTS from "../config/api";
import { apiRequest, logSystemError } from "./httpClient";

export const downloadCv = async (filename, token) => {
  return apiRequest(`${API_ENDPOINTS.CV_DOWNLOAD}/${filename}`, {
    method: "GET",
    token,
    responseType: "blob",
    fallbackMessage: "Failed to download CV",
    errorCode: "CV_DOWNLOAD_FAILED",
  });
};

export const getCandidateById = async (candidateId, token) => {
  return apiRequest(`${API_ENDPOINTS.CANDIDATES}/${candidateId}`, {
    method: "GET",
    token,
    fallbackMessage: `Failed to fetch candidate with ID: ${candidateId}`,
    errorCode: "CANDIDATE_PROFILE_FETCH_FAILED",
  });
};

export const updateProfile = async (candidateId, userData, cvFile, token) => {
  const formData = new FormData();

  formData.append(
    "dto",
    new Blob([JSON.stringify(userData)], {
      type: "application/json",
    })
  );

  if (cvFile) {
    formData.append("cvFile", cvFile);
  }

  try {
    return await apiRequest(`${API_ENDPOINTS.CANDIDATES}/${candidateId}`, {
      method: "PUT",
      token,
      body: formData,
      fallbackMessage: "Erro ao atualizar candidato",
      errorCode: "CANDIDATE_PROFILE_UPDATE_FAILED",
    });
  } catch (error) {
    logSystemError(error, "profile:update");
    throw error;
  }
};
